import translatePipelineIntegration from 'app/shared/translation/integrations/translatePipelineIntegration';

const PIPELINE_VARIABLE_PLACEHOLDER = '$$PIPELINE_VARIABLE$$';

export default function transformRevisionForDiff({ playbook, integration }) {
  const { id, revision, playbookJson, connectionJson, vars, pipeline_variables } = playbook;

  const pipelineIntegration = {
    pipelineIntegrationConsent: null,
    disabled: false,
    stagedRevision: {
      id,
      pipelineVars: buildPlaceholderPipelineVars(pipeline_variables),
      playbook: {
        revision,
        vars,
        playbookJson,
        connectionJson,
        pipeline_variables,
        integration: {
          id: integration.id,
          starterkitId: integration.starterkitId,
        },
      },
    },
  };

  return translatePipelineIntegration(pipelineIntegration);
}

function buildPlaceholderPipelineVars(pipelineVariables) {
  if (!Array.isArray(pipelineVariables)) {
    return {};
  }
  return pipelineVariables.reduce((acc, pipelineVariable) => {
    acc[pipelineVariable.name] = PIPELINE_VARIABLE_PLACEHOLDER;
    return acc;
  }, {});
}
